import { CmsApiImageGalleryBlockData } from 'modules/cms/api/types/blocks/CmsApiImageGalleryBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpImageGalleryBlock } from './CmsAmpImageGalleryBlock';
import { CmsImageGalleryBlock } from './CmsImageGalleryBlock';

export const CmsImageGalleryBlockMapping: CmsBlockMapping<CmsApiImageGalleryBlockData> =
  {
    invariant: [
      {
        prop: 'images',
        msg: 'Images required for Image Gallery',
      },
    ],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsImageGalleryBlock,
    AmpComponent: CmsAmpImageGalleryBlock,
  };
